module.exports = __webpack_public_path__ + "static/media/crutches.5218b6a9.svg";